import { lazy } from 'react';

export default {
  path: '/',
  component: lazy(() => import(/* webpackChunkName: 'Landing' */ './page'))
};
